import { createPageLoadMetric } from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import { INACCESSIBLE_PAGE_LOAD_KEY } from '@confluence/browser-metrics/entry-points/metric-keys/pageLoadKey.ts';

export const INACCESSIBLE_PAGE_LOAD = createPageLoadMetric({
	key: INACCESSIBLE_PAGE_LOAD_KEY,
});
